import React from "react";

import { Countries } from "../components/Countries";

export function MercadoPagoSignUp() {
  return (
    <>
      <h2 style={{ color: "gray" }}>
        Para registrarte o actualizar las credenciales de tu cuenta de Mercado
        Pago por favor elige el país correspondiente:
      </h2>
      <Countries />
    </>
  );
}
